import React, { FC, useEffect, useState } from 'react';
import { DatePickerModal } from 'QuoteApp/components';
import { transformSaveEffectiveDateRequest } from 'QuoteApp/services/endpoints/PostSaveSummary';
import { useAppContext } from 'QuoteApp/services/providers';
import { getErrorMessage } from 'QuoteApp/utils';
import { mergeInProgressDataFromSummary } from 'QuoteApp/screens/Summary/Summary';
import { convertDateIgnoringLocalTimeZone } from 'Shared/utils';

export const EffectiveDate: FC = () => {
  const {
    details,
    refreshRate,
    setDetails,
    refreshConfig,
    api,
    config,
  } = useAppContext();
  const [error, setError] = useState<string | undefined>();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [effectiveDate, setEffectiveDate] = useState<string | Date>(
    details.effectiveDate.value
  );

  // For use in minDateAllowed, set to midnight for testing convenience
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  useEffect(() => {
    setError(details.effectiveDate.errors.length ? 'Invalid date' : undefined);
    setEffectiveDate(details.effectiveDate.value);
  }, [details.effectiveDate]);

  if (!config) return null;

  return (
    <>
      <DatePickerModal
        modalHeader="Effective Date"
        label="Effective Date"
        name="effective-date"
        minDateAllowed={
          config.effectiveDates?.startDate
            ? convertDateIgnoringLocalTimeZone(config.effectiveDates.startDate)
            : today
        }
        maxDateAllowed={
          config.effectiveDates?.endDate
            ? convertDateIgnoringLocalTimeZone(config.effectiveDates.endDate)
            : undefined
        }
        startDate={new Date(effectiveDate)}
        errorMessage={error}
        loading={isSubmitting}
        onDateChange={date => {
          const dateString = `${date.getFullYear()}-${date.getMonth() +
            1}-${date.getDate()}`;
          setEffectiveDate(date);
          setIsSubmitting(true);
          api
            .saveAppData(
              {
                data: dateString,
                transformRequest: transformSaveEffectiveDateRequest,
              },
              { suppressDefaultToastError: true }
            )
            .then(response => {
              setError(undefined);
              const mergedDetails = mergeInProgressDataFromSummary(
                details,
                response.data
              );
              setDetails(mergedDetails);
              refreshConfig();
              refreshRate();
            })
            .catch(error => {
              setError(getErrorMessage(error));
            })
            .finally(() => setIsSubmitting(false));
        }}
      />
    </>
  );
};
